import { useDispatch } from 'react-redux'
import { setPostsTypeStatus } from 'store'
import { COLORS } from 'utils/styles'
import {
  CustomBtn,
  CustomMainBox
} from './styled'

const blogTypes = [
  'archived',
  'scheduled',
  'posted'
]

export const PostTypes = ({ postsTypeStatus }) => {
  const dispatch = useDispatch()

  const animateBg = (typeStatus) => {
    if (postsTypeStatus === typeStatus) {
      return COLORS.whiteBlackGradientTopToBot2
    }

    return 'linear-gradient(180deg, rgb(255, 215, 0) 0%, rgb(255, 215, 0) 100%)'
  }

  const transitionForAll = {
    type: 'tween',
    duration: 0.8,
    background: {
      type: 'tween',
      duration: 0.3
    }
  }

  return (
    <CustomMainBox>
      {
        blogTypes.map((blogType) => (
          <CustomBtn
            initial={false}
            animate={{ background: animateBg(blogType) }}
            transition={transitionForAll}
            overflow="hidden"
            pointerEvents={postsTypeStatus === blogType ? 'none' : 'auto'}
            onClick={() => dispatch(setPostsTypeStatus(blogType))}
          >
            {blogType.charAt(0).toUpperCase() + blogType.slice(1)}
          </CustomBtn>
        ))
      }
    </CustomMainBox>
  )
}
